import { UseToastOptions, useToast } from "@chakra-ui/react";

// Extend UseToastOptions to include fontSize
interface CustomToastOptions extends UseToastOptions {
  fontSize?: string;
}

const useCustomToast = () => {
  const toast = useToast();

  return (options?: CustomToastOptions) => {
    toast({
      title:
        options?.title ||
        "Terjadi kesalahan, tunggu beberapa saat lagi dan coba kembali",
      description:
        options?.description ||
        (options?.status === "error"
          ? "Tunggu beberapa saat lagi dan coba kembali"
          : undefined),
      status: options?.status || "error",
      duration:
        options?.duration || (options?.status === "error" ? 6000 : 5000),
      isClosable: true,
      containerStyle: {
        fontSize: options?.fontSize || "14px", // Set font size within containerStyle
        ...options?.containerStyle,
      },
      ...options,
    });
  };
};

export default useCustomToast;
